import React from "react";

export interface DocumentSvgProps {
  color?: any;
}

export default function DocumentSvg(props: DocumentSvgProps) {
  const svgColor = props.color || "#1C64F2";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="22"
      fill="none"
      viewBox="0 0 18 22"
    >
      <path
        stroke={svgColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11 1.27V5.4c0 .56 0 .84.109 1.054a1 1 0 00.437.437c.214.11.494.11 1.054.11h4.13M11 16H5m8-4H5m12-3.012V16.2c0 1.68 0 2.52-.327 3.162a3 3 0 01-1.311 1.311C14.72 21 13.88 21 12.2 21H5.8c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.311C1 18.72 1 17.88 1 16.2V5.8c0-1.68 0-2.52.327-3.162a3 3 0 011.311-1.311C3.28 1 4.12 1 5.8 1h3.212c.734 0 1.1 0 1.446.083.306.073.598.195.867.36.303.185.562.444 1.08.963l3.19 3.188c.518.519.777.778.963 1.081a3 3 0 01.36.867c.082.346.082.712.082 1.446z"
      ></path>
    </svg>
  );
}
